import React from 'react';

import Plus from '@/images/icons/plus.svg';
import Minus from '@/images/icons/sub.svg';

import styles from './styles.module.scss';

interface Props {
  number: number;
  setNumber: (number: number) => void;
  max?: number;
  min?: number;
}

const Counter = ({ number, setNumber, max = 99, min = 0 }: Props) => {
  const add = () => setNumber(number + 1 > max ? max : number + 1);
  const sub = () => setNumber(number - 1 < min ? min : number - 1);

  return (
    <div className={styles.counter}>
      <button className={styles.sub} onClick={sub}>
        <Minus />
      </button>
      <div>{number}</div>
      <button className={styles.add} onClick={add}>
        <Plus />
      </button>
    </div>
  );
};

export default Counter;
